<template>
  <el-dialog
      :width="screenWidth<=976?'85%':'964px'"
      append-to-body
      :show-close="true"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      @closed="closeDialog"
      :close-on-click-modal="false">
    <div slot="title" class="header">
      <div class="header-title">Billing Details</div>
      <div class="header-desc">The following information is only used for billing information sent by the bank</div>
    </div>
    <billDetailsForm ref="billDetailsForm"/>
    <div slot="footer" class="footer">
      <el-button type="primary" v-loading="loadingSubmit" @click="submitUserInfo">Submit</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getUserInfo,
  MessageError,
  formatObj
} from "@/util/util";
import {
  onlypay
} from "@/request/requests"
import billDetailsForm from "@/components/billDetailsForm";
export default {
  name: "billingDetails",
  props:{
    form1Obj:{
      type:Object,
      default:()=>{
        return {
          goodsid: "",
          skuid: "",
          num: "",
          buytype: "",
          paycode: "",
          discountcode: "",
        }
      }
    }
  },
  components:{
    billDetailsForm
  },
  data() {
    return {
      screenWidth: null,
      dialogFormVisible: false,
      userinfo:"",
      submitFlag:false,
      loadingSubmit:false
    }
  },
  methods: {
    init() {
      this.dialogFormVisible = true;
      this.$nextTick(()=>{
        this.$refs['billDetailsForm'].init();
      })
    },
    submitUserInfo(){
      this.$refs.billDetailsForm.$refs.billFormRef.validate((valid) => {
        if (!valid) return;
        this.doSubmit();
      });
    },
    async doSubmit(){
      if(this.submitFlag){
        return
      }
      this.submitFlag = true;
      this.loadingSubmit = true;

      let billObj= formatObj(this.$refs.billDetailsForm.billForm);
      billObj.address = billObj.address + billObj.address1;
      let params = {
        ...billObj,
        ...this.form1Obj,
        userid: this.userinfo.id,
        email: this.userinfo.email,
        sessionid: sessionStorage.getItem("session_id")
      }

      let res = await onlypay(params);
      if (res.status == "200") {
        const url = res.data.payParams.payUrl;
        window.open(url, "_self");
      } else {
        MessageError(res.msg);
      }
    },
    closeDialog(){
      this.dialogFormVisible = false;
      this.$nextTick(()=>{
        this.$refs['billDetailsForm'].reset();
      })
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    },
  },
  mounted() {
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/variables.scss";
::v-deep .el-dialog {
  margin-top:4vh!important;
  &__header, &__body, &__footer {
    padding: 0;
  }
  .header{
    padding:20px 20px 10px 20px;;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.0784313725);
    &-title{
      font-size:25px;
      font-weight:bold;
      margin-bottom:2px;
      color:$black-2;
    }
    &-desc{
      font-size:14px;
      color:$red-2;
    }
  }
  .billForm{
    height: calc(100vh - 333px);
    padding:30px 20px;
  }
  .footer{
    padding: 20px;
    border-top: 1px solid #f5f2f2;
    box-shadow: 0 -12px 16px rgba(0, 0, 0, 0.0588235294);
    .el-button{
      font-size: 14px;
      padding: 20px 40px !important;
      border-radius: 34px !important;
      width: 100%;
    }
    .el-loading-mask{
      border-radius: 34px!important;
    }
  }

}
</style>